import { render, staticRenderFns } from "./questionnaireInput.vue?vue&type=template&id=520f44ff&scoped=true"
import script from "./questionnaireInput.vue?vue&type=script&lang=js"
export * from "./questionnaireInput.vue?vue&type=script&lang=js"
import style0 from "./questionnaireInput.vue?vue&type=style&index=0&id=520f44ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f44ff",
  null
  
)

export default component.exports